export const DETAIL_DISPLAY = {
  SHOW: 'show',
  HIDE: 'hide',
  DISABLE: 'disable',
};
